<template>
  <el-dialog
    class="platform-info-dialog"
    title="平台信息"
    width="580px"
    :close-on-click-modal="false"
    :visible.sync="showDialog"
    :destroy-on-close="true"
    @close="close()"
  >
    <el-descriptions v-if="platformInfo.sip" :column="2" border>
      <el-descriptions-item label="编号">{{ platformInfo.sip.id }}</el-descriptions-item>
      <el-descriptions-item label="域">{{ platformInfo.sip.domain }}</el-descriptions-item>
      <el-descriptions-item label="IP">{{ platformInfo.sip.showIp }}</el-descriptions-item>
      <el-descriptions-item label="端口">{{ platformInfo.sip.port }}</el-descriptions-item>
      <el-descriptions-item label="密码">{{ platformInfo.sip.password }}</el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        showDialog: false,
        platformInfo: {
          sip: {},
        }
      };
    },
    methods: {
      openDialog: function (data) {
        this.showDialog = true;
        this.platformInfo = data;
      },
      close: function () {
        this.showDialog = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
.platform-info-dialog {
  .pass-input {
    max-width: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/platformInfo.vue